import React from 'react'
import CartContainer from '../../../../Components/Apps/ECommerce/Cart'

export default function Cart() {
  return (
    <div className='page-body'>
        <CartContainer/>
    </div>
  )
}
